// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__FzVp0","author":"Table_author__S2t7f","authorImage":"Table_authorImage__1cnFC","unreadRow":"Table_unreadRow__332Gy"};